import logoConseilArts from '../../img/partners/partner-conseil-arts-mtl.svg';
import logoCanada from '../../img/partners/partner-canada.svg';
import logoCouncilForTheArts from '../../img/partners/partner-council-for-the-arts.svg';
import logoQuebec from '../../img/partners/partner-quebec.svg';

export default [
    {
        id: 'conseil-arts-montreal',
        url: 'https://www.artsmontreal.org/en',
        image: {
            url: logoConseilArts
        },
    },
    {
        id: 'quebec',
        url: 'https://www.quebec.ca/en/',
        image: {
            url: logoQuebec
        },
    },
    {
        id: 'canada-council-of-arts',
        url: 'https://canadacouncil.ca/',
        image: {
            url: logoCouncilForTheArts
        },
    },
    {
        id: 'canada',
        url: 'https://canada.ca/',
        image: {
            url: logoCanada
        },
    },
];